/**
 * Open Natter Ably Channel Helpers
 */

export interface OpenNatterChannels {
  personal: string;
  broadcast: string;
}

/**
 * Get Ably channel names for Open Natter
 * @param id - Open Natter event ID
 * @param userId - The user's numeric backend account ID (from `selectUserAccountId` / `account.id`),
 *   NOT the Keycloak `sub` claim — the backend publishes self-state to `:user:{account.id}`, so the
 *   personal channel must match or it never receives messages.
 * @returns Object with personal and broadcast channel names
 */
export const getOpenNatterChannels = (id: string, userId: string): OpenNatterChannels => ({
  personal: `open-natters:${id}:user:${userId}`,
  broadcast: `open-natters:${id}`,
});
